





































import Vue from "vue";
import CustomCheckbox from "@/components/Input/Checkbox.vue";

export default Vue.extend({
  name: "CustomTable",
  components: { CustomCheckbox },
  props: {
    data: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    hide_checkbox: {
      type: Boolean,
      default: false
    },
    selectedChange: {
      type: Function,
      default: () => undefined
    },
    selectedAll: {
      type: Function,
      default: () => undefined
    },
    selected: {
      type: Array,
      default: () => []
    },
    hideActions: {
      type: Boolean,
      default: false
    },
    onRowClick: {
      type: Function,
      default: () => undefined
    },
    currentItems: {
      type: Function,
      default: () => undefined
    },
    customFilter: {
      type: Function,
      default: () => undefined
    },
    sortBy: {
      type: String,
      default: undefined
    },
    sortDesc: {
      type: Boolean,
      default: undefined
    },
    search: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false
    },
    defaultItemPerPage: {
      type: Number,
      default: 10
    },
    pagination: {
      type: Function,
      default: () => undefined
    }
  },
  data() {
    return {
      select: false,
      test: "selected"
    };
  },
  methods: {
    onSelectChange(): void {
      this.select = !this.select;
      this.selectedAll(this.select);
    },
    getSlot(t: string): string {
      return t;
    }
  },
  watch: {
    selected(): void {
      if (this.selected.length === 0) this.select = false;
    }
  }
});
